import { ComponentsProps, ComponentsOverrides, ComponentsVariants, menuItemClasses, Theme } from '@mui/material';
import { baseTheme } from '../base-theme';

export const MuiMenuItem: {
    defaultProps?: ComponentsProps['MuiMenuItem'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiMenuItem'];
    variants?: ComponentsVariants['MuiMenuItem'];
} = {
    defaultProps: {},
    styleOverrides: {
        root: {
            '&::before': {
                // added to work around carrot-frontend global css
                content: 'unset',
            },
            padding: baseTheme.spacing(baseTheme.tokens.spacing.md, baseTheme.tokens.spacing.md),
            [`&.${menuItemClasses.focusVisible}`]: {
                outlineStyle: 'none',
            },
        },
    },
};
